const CHILD_USER_TYPES = ["child", "children"];

const REQUIRED_KYC_KEYS = {
  child: [
    "address",
    "bank_account",
    "current_address",
    "disability",
    "phone",
    "profile",
  ],
  default: [
    "address",
    "bank_account",
    "current_address",
    "disability",
    "employment_status",
    "financial",
    "id_uploaded",
    "monpep",
    "phone",
    "profile",
  ],
};

export const isChildUserByIndividual = (individual) =>
  CHILD_USER_TYPES.includes(individual);

export const isKycIncomplete = (user, kycStatus = {}) => {
  if (!user) {
    return true;
  }

  if (user.individual === "company") {
    return false;
  }

  const isChildUser = isChildUserByIndividual(user.individual);
  const requiredKycKeys = isChildUser
    ? REQUIRED_KYC_KEYS.child
    : REQUIRED_KYC_KEYS.default;

  return (
    Object.keys(kycStatus).length === 0 ||
    requiredKycKeys.some((key) => kycStatus[key] === false) ||
    (!isChildUser &&
      kycStatus.is_disabled &&
      !kycStatus.disability_id_uploaded)
  );
};
